import { useState } from "react";
import { FaTools } from "react-icons/fa";

import LockerCard from "./OpenLockerCard";
import SearchPackage from "./SearchPackages";
import PageContainer from "../../../../components/layout/PageContainer";
import PageHeader from "../../../../components/layout/PageHeader";
import ContentCard from "../../../../components/layout/ContentCard";
import { translate } from "../../../../utils/Common";

const Support = () => {
  const [pachageInfo, setPackageInfo] = useState(null);

  return (
    <PageContainer>
      <PageHeader
        title={translate("global.support")}
        subtitle={translate("dashboard.platforms.support.description")}
        icon={<FaTools size={24} />}
      />

      <ContentCard padding="md">
        <SearchPackage setPackageInfo={setPackageInfo} />
      </ContentCard>

      {pachageInfo && <LockerCard pachageInfo={pachageInfo} />}
    </PageContainer>
  );
};

export default Support;
